/* @ngInject */
const saleAsk = (
  valueHandler,
) => {
  const self = {}

  self.getAxletreesWeight = (_axletrees, _decision = false) => {
    let totalWeight = 0
    for (let index = 0; index < _axletrees.length; index++) {
      const axletree = _axletrees[index]
      if (axletree.decision === _decision || !_decision) {
        if (axletree.weight) {
          totalWeight += axletree.weight
        }
      }
    }
    return totalWeight
  }

  self.getSterilesWeight = (_steriles) => {
    let totalWeight = 0
    for (let index = 0; index < _steriles.length; index++) {
      const sterile = _steriles[index]
      if (sterile.weight) {
        totalWeight += sterile.weight
      }
    }
    return totalWeight
  }

  self.getPiecesWeight = (_pieces) => {
    let totalWeight = 0
    for (let index = 0; index < _pieces.length; index++) {
      const piece = _pieces[index]
      if (piece.weight) {
        totalWeight += piece.weight
      }
    }
    return totalWeight
  }

  self.getWagonWeight = (_wagon) => {
    if (!_wagon.tare) {
      return 0
    }
    let wagonWeight = _wagon.tare
    wagonWeight -= self.getAxletreesWeight(_wagon.axletrees)
    wagonWeight -= self.getSterilesWeight(_wagon.steriles)
    wagonWeight -= self.getPiecesWeight(_wagon.pieces)
    return wagonWeight
  }

  self.getWagonsWeight = (_wagons) => {
    if (!_wagons) {
      return 0
    }
    let totalWeight = 0
    for (let index = 0; index < _wagons.length; index++) {
      const wagon = _wagons[index]
      totalWeight += self.getWagonWeight(wagon)
    }
    return totalWeight
  }

  self.getScrapWeight = (_wagons) => {
    if (!_wagons) {
      return 0
    }
    let totalWeight = 0
    for (let index = 0; index < _wagons.length; index++) {
      const wagon = _wagons[index]
      totalWeight += self.getAxletreesWeight(wagon.axletrees)
      totalWeight += self.getSterilesWeight(wagon.steriles)
      totalWeight += self.getPiecesWeight(wagon.pieces)
    }
    return totalWeight
  }

  self.getTotalPiecesWeight = (_wagons) => {
    if (!valueHandler.isArray(_wagons)) {
      return 0
    }
    let totalWeight = 0
    for (let index = 0; index < _wagons.length; index++) {
      const wagon = _wagons[index]
      totalWeight += self.getPiecesWeight(wagon.pieces)
    }
    return totalWeight
  }

  self.getTotalSterilesWeight = (_wagons) => {
    if (!valueHandler.isArray(_wagons)) {
      return 0
    }
    let totalWeight = 0
    for (let index = 0; index < _wagons.length; index++) {
      const wagon = _wagons[index]
      totalWeight += self.getSterilesWeight(wagon.steriles)
    }
    return totalWeight
  }

  self.getTotalAxletreesWeight = (_wagons, _decision = false) => {
    if (!valueHandler.isArray(_wagons)) {
      return 0
    }
    let totalWeight = 0
    for (let index = 0; index < _wagons.length; index++) {
      const wagon = _wagons[index]
      totalWeight += self.getAxletreesWeight(wagon.axletrees, _decision)
    }
    return totalWeight
  }

  return self
}
export default saleAsk



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/computeWeight.service.js